import {
  FacilityAddress,
  FacilityImage,
  FacilitySummaryResponse,
} from "@repo/shared-types";
import { Feature, Point, GeoJsonProperties, Geometry } from "geojson";

export type ClusterPointProperties = {
  id: string;
  name: string;
  address: Partial<FacilityAddress>;
  image?: Partial<FacilityImage> | null;
  categoryId: string;
  cluster: boolean;
};

export type ClusterPoint = Feature<Point, ClusterPointProperties>;

export function mapFacilityToClusterPoint(
  facility: FacilitySummaryResponse
): ClusterPoint {
  const {
    id,
    categoryId,
    coordinates: { longitude, latitude },
  } = facility;
  return {
    type: "Feature" as const,
    id: id,
    properties: {
      id: id,
      name: facility.name,
      address: facility.address,
      image: facility.image,
      categoryId: categoryId,
      cluster: false,
    },
    geometry: {
      type: "Point" as const,
      coordinates: [longitude, latitude],
    },
  };
}

export function isClusterPoint(
  feature: Feature<Geometry, GeoJsonProperties>
): feature is ClusterPoint {
  return feature.geometry.type === "Point" && feature.properties !== undefined;
}
